<template>
  <div class="box-unlock-description flex flex-col justify-center">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "BoxUnlockDescription"
};
</script>

<style scoped>
.box-unlock-description {
  height: 7.616rem;
  flex: 0 0 7.616rem;
}
@media screen and (min-height: 1024px) {
  .box-unlock-description {
    height: 8.704rem;
    flex: 0 0 8.704rem;
  }
}
</style>
